const presentValue = (value?: string | null) => {
  const text = value?.trim() || ''
  return text.toLowerCase() === 'null' ? '' : text
}

export const formatJackpotTableLabel = (table: { id: number; name?: string | null; login?: string | null }) => {
  const name = presentValue(table.name)
  const login = presentValue(table.login)
  return `#${table.id}${name ? ` — ${name}` : ''}${login ? ` (${login})` : ''}`
}
